import { useEffect, useState } from "react";
import api from "../lib/api";

export default function Reports() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/dashboard/stats").then((r) => setStats(r.data)); }, []);
  if (!stats) return <div className="text-muted-foreground">Loading…</div>;

  const conv = stats.total_leads ? Math.round((stats.signed_quotes / stats.total_leads) * 100) : 0;

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-head font-extrabold tracking-tight">Reports</h1>
        <p className="text-muted-foreground">Lead & sales activity tracking</p>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {[["Total Leads", stats.total_leads], ["Contacted / Worked", stats.worked],
          ["Not Contacted", stats.not_contacted], ["Conversion %", conv + "%"],
          ["Total Quotes", stats.total_quotes], ["Signed Quotes", stats.signed_quotes]].map(([l, v]) => (
          <div key={l} className="bg-card border border-border rounded-md p-6 shadow-sm">
            <div className="label-caps">{l}</div>
            <div className="text-3xl font-head font-extrabold mt-2">{v}</div>
          </div>
        ))}
      </div>
      <div className="bg-card border border-border rounded-md p-6 shadow-sm overflow-x-auto">
        <h3 className="font-head font-semibold mb-4">Per Rep Breakdown</h3>
        <table className="w-full text-sm min-w-[520px]" data-testid="reports-table">
          <thead><tr className="text-left label-caps border-b border-border">
            <th className="py-2">Rep</th><th>Role</th><th>Leads</th><th>Quotes</th><th>Signed</th></tr></thead>
          <tbody>
            {stats.rep_performance.map((r, i) => (
              <tr key={i} className="border-b border-border/50">
                <td className="py-2 font-medium">{r.name}</td><td className="capitalize">{r.role.replace("_", " ")}</td>
                <td>{r.leads}</td><td>{r.quotes}</td><td>{r.signed}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
